/**
 * Le rotte dei link del Sinottico (feature 147, US5): Reg. → ordine di produzione, codice articolo
 * → dettaglio articolo, riga evento → dettaglio evento. Tutte si aprono in una **nuova scheda**:
 * il Sinottico resta aperto sul monitor di reparto.
 *
 * Ogni funzione restituisce `null` quando manca il dato che identifica la destinazione: il
 * template mostra allora testo semplice, mai un link che porta a una pagina vuota.
 */
export function rottaOrdine(idDocumento?: number | null, idRiga?: number | null): unknown[] | null {
  if (!idDocumento) {
    return null;
  }
  return idRiga ? ['/ordini/storia', idDocumento, idRiga] : ['/ordini/storia', idDocumento];
}

export function rottaArticolo(codice?: string | null): unknown[] | null {
  return codice ? ['/articoli/detail'] : null;
}

/** Il dettaglio articolo legge il codice dalla query string (`ArticoliDetailComponent`). */
export function parametriArticolo(codice?: string | null): {codice: string} | null {
  return codice ? {codice} : null;
}

export function rottaEvento(id?: number | null): unknown[] | null {
  return id ? ['/eventi/detail', id] : null;
}
